import { action, autorun, observable } from 'mobx'
import { ROUTE_CHANGE_HANDLERS } from '../../routes/route-change-handlers'
import { ROUTING_STORE } from '../stores'
import { getStore } from '../stores-repository'

export class AppBarStore {

    @observable
    title = ''

    nextRoute = null

    prevRoute = null

    routingStore = getStore(ROUTING_STORE)

    startRouteWatching = () => {
        autorun(() => {
            this.prevRoute = this.nextRoute
            this.nextRoute = this.routingStore.location.pathname

            if (!this.nextRoute || this.prevRoute === this.nextRoute) return

            if (this.prevRoute) {
                ROUTE_CHANGE_HANDLERS.some(handler => {
                    const match = this.prevRoute.match(handler.routeMatcher)
                    if (match) {
                        if (handler.onLeave) {
                            handler.onLeave(this.nextRoute, this.prevRoute)
                        }
                    }
                    return match
                })
            }

            ROUTE_CHANGE_HANDLERS.some(handler => {
                const match = this.nextRoute.match(handler.routeMatcher)
                if (match) {
                    if (handler.onEnter) {
                        handler.onEnter(this.nextRoute, this.prevRoute)
                    }
                }
                return match
            })
        })
    }

    @action
    updateState = state => {
        this.title = state.title
    }
}
